const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}

export const MoneyFormate = (num:number)=>{
    return money(num)
}